// Mattress quiz pasted into an article body. The article editor strips the quiz's own
// <script> and its empty result block, so both live here.
(() => {
  const RESULTS = [
    {
      maxScore: 2,
      icon: "✨",
      title: "You're in Good Shape",
      text: "Your mattress is likely still supporting you well. Rotate it every few months, use a quality mattress protector, and add a topper if you want a comfort boost.",
    },
    {
      maxScore: 5,
      icon: "🤔",
      title: "Time to Pay Attention",
      text: "Your mattress is showing early warning signs. A mattress topper could help in the short term, but start planning for a replacement within the next year.",
    },
    {
      maxScore: Infinity,
      icon: "🛏️",
      title: "It's Time for a New Mattress",
      text: "Your current mattress isn't giving you the support you need for quality sleep. We're here to help you find the perfect match for your sleep style and budget.",
    },
  ];

  const ensureResult = (form) => {
    const existing = document.getElementById("hfmqResult");
    // The editor can leave the wrapper after stripping its empty children.
    if (existing?.querySelector("#hfmqResultIcon")) return existing;
    existing?.remove();

    const result = document.createElement("div");
    result.id = "hfmqResult";
    result.className = "hfmq-result";
    result.innerHTML =
      '<span id="hfmqResultIcon" class="hfmq-result-icon" aria-hidden="true"></span>' +
      '<h4 id="hfmqResultTitle"></h4>' +
      '<p id="hfmqResultText"></p>';
    form.after(result);
    return result;
  };

  // Lives outside the hidden result box, so it is in the accessibility tree before the first click.
  const ensureStatus = (result) => {
    const existing = document.getElementById("hfmqStatus");
    if (existing) return existing;

    const status = document.createElement("div");
    status.id = "hfmqStatus";
    status.className = "visually-hidden";
    status.setAttribute("role", "status");
    result.after(status);
    return status;
  };

  const init = () => {
    const form = document.getElementById("mattressQuiz");
    const button = document.getElementById("hfmqBtn");
    if (!form || !button) return;

    const result = ensureResult(form);
    const status = ensureStatus(result);

    button.addEventListener("click", () => {
      const score = [...form.querySelectorAll("input:checked")].reduce(
        (sum, input) => sum + (parseInt(input.value, 10) || 0),
        0,
      );
      const outcome = RESULTS.find((item) => score <= item.maxScore);

      result.style.removeProperty("display");
      result.classList.add("_visible");
      result.querySelector("#hfmqResultIcon").textContent = outcome.icon;
      result.querySelector("#hfmqResultTitle").textContent = outcome.title;
      result.querySelector("#hfmqResultText").textContent = outcome.text;
      status.textContent = `${outcome.title}. ${outcome.text}`;
      result.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
